import type { PickersLocaleText } from '@mui/x-date-pickers/locales';

/**
 * Serbian Latin locale text for MUI X DatePicker components.
 * Provides translations for UI elements like toolbar titles and action buttons.
 */
export const srLatnLocaleText: Partial<PickersLocaleText> = {
  // Calendar navigation
  previousMonth: 'Prethodni mesec',
  nextMonth: 'Sledeći mesec',

  // View navigation
  openPreviousView: 'Otvori prethodni prikaz',
  openNextView: 'Otvori sledeći prikaz',

  // DateRange labels
  start: 'Početak',
  end: 'Kraj',
  startDate: 'Datum početka',
  startTime: 'Vreme početka',
  endDate: 'Datum završetka',
  endTime: 'Vreme završetka',

  // Action bar
  cancelButtonLabel: 'Otkaži',
  clearButtonLabel: 'Obriši',
  okButtonLabel: 'U redu',
  todayButtonLabel: 'Danas',
  nextStepButtonLabel: 'Sledeće',

  // Toolbar titles
  datePickerToolbarTitle: 'Izaberite datum',
  dateTimePickerToolbarTitle: 'Izaberite datum i vreme',
  timePickerToolbarTitle: 'Izaberite vreme',
  dateRangePickerToolbarTitle: 'Izaberite opseg datuma',
  timeRangePickerToolbarTitle: 'Izaberite opseg vremena',

  // Calendar labels
  calendarWeekNumberHeaderLabel: 'Broj nedelje',
  calendarWeekNumberHeaderText: '#',

  // Open Picker labels
  fieldClearLabel: 'Obriši',

  // Table labels
  timeTableLabel: 'izaberite vreme',
  dateTableLabel: 'izaberite datum',

  // View names
  year: 'Godina',
  month: 'Mesec',
  day: 'Dan',
  weekDay: 'Dan u nedelji',
  hours: 'Sati',
  minutes: 'Minuti',
  seconds: 'Sekunde',
  meridiem: 'Pre/posle podne',

  // Common
  empty: 'Prazno',
};

/**
 * Serbian Cyrillic locale text for MUI X DatePicker components.
 * Provides translations for UI elements like toolbar titles and action buttons.
 */
export const srCyrlLocaleText: Partial<PickersLocaleText> = {
  // Calendar navigation
  previousMonth: 'Претходни месец',
  nextMonth: 'Следећи месец',

  // View navigation
  openPreviousView: 'Отвори претходни приказ',
  openNextView: 'Отвори следећи приказ',

  // DateRange labels
  start: 'Почетак',
  end: 'Крај',
  startDate: 'Датум почетка',
  startTime: 'Време почетка',
  endDate: 'Датум завршетка',
  endTime: 'Време завршетка',

  // Action bar
  cancelButtonLabel: 'Откажи',
  clearButtonLabel: 'Обриши',
  okButtonLabel: 'У реду',
  todayButtonLabel: 'Данас',
  nextStepButtonLabel: 'Следеће',

  // Toolbar titles
  datePickerToolbarTitle: 'Изаберите датум',
  dateTimePickerToolbarTitle: 'Изаберите датум и време',
  timePickerToolbarTitle: 'Изаберите време',
  dateRangePickerToolbarTitle: 'Изаберите опсег датума',
  timeRangePickerToolbarTitle: 'Изаберите опсег времена',

  // Calendar labels
  calendarWeekNumberHeaderLabel: 'Број недеље',
  calendarWeekNumberHeaderText: '#',

  // Open Picker labels
  fieldClearLabel: 'Обриши',

  // Table labels
  timeTableLabel: 'изаберите време',
  dateTableLabel: 'изаберите датум',

  // View names
  year: 'Година',
  month: 'Месец',
  day: 'Дан',
  weekDay: 'Дан у недељи',
  hours: 'Сати',
  minutes: 'Минути',
  seconds: 'Секунде',
  meridiem: 'Пре/после подне',

  // Common
  empty: 'Празно',
};

/**
 * Returns the appropriate Serbian locale text based on app language.
 */
export const getDatePickerLocaleText = (
  appLanguage: string
): Partial<PickersLocaleText> => {
  if (appLanguage === 'sr-Cyrl') {
    return srCyrlLocaleText;
  }
  return srLatnLocaleText;
};

